import styled from "styled-components";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";
import { theme as toyotaTheme } from "../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";

export const WinterToggle = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const Label = styled.span`
    display: none;
    @media ${getBreakpoint("up", "md")} {
        display: inline-block;
    }
`;

export const ToggleStates = styled.button<{ isActive: boolean }>`
    display: inline-flex;
    position: relative;
    justify-content: space-around;
    width: 80px;
    margin-left: 10px;
    padding: 10px;
    font-size: 1.6rem;
    color: white;
    background-color: ${({ isActive }) => (isActive ? toyotaTheme.colors.primaryBlack : toyotaTheme.colors.grey7)};
    border: none;
    border-radius: 50px;

    &::after {
        display: block;
        position: absolute;
        top: 3px;
        left: ${({ isActive }) => (isActive ? 45 : 5)}px;
        width: 30px;
        height: 30px;
        content: " ";
        background-color: ${({ theme }) => theme.color.lightest};
        border-radius: 36px;
        transition: left 0.3s;
    }

    html[dir="rtl"] & {
        margin-left: 0;
        margin-right: 10px;
        &::after {
            left: auto;
            right: ${({ isActive }) => (isActive ? 45 : 5)}px;
        }
    }
`;
